import React, { useState } from "react";

import type { IProps as ButtonMenuProps } from "@components/molecules/Menu/MenuItem/ButtonMenu";
import ButtonMenu from "@components/molecules/Menu/MenuItem/ButtonMenu";
import type { IProps as LinkMenuProps } from "@components/molecules/Menu/MenuItem/LinkMenu";
import LinkMenu from "@components/molecules/Menu/MenuItem/LinkMenu";

interface IProps extends LinkMenuProps, ButtonMenuProps {
  type: "link" | "button";
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

function MenuItem({ type, ...props }: IProps) {
  const [isHover, setIsHover] = useState<boolean>(false);

  return (
    <li
      onMouseEnter={() => {
        setIsHover(true);
        props.onMouseEnter?.();
      }}
      onMouseLeave={() => {
        setIsHover(false);
        props.onMouseLeave?.();
      }}
    >
      {type === "link" && (
        <LinkMenu
          className={props.className}
          goToUrl={props.goToUrl}
          name={props.name}
          showIcon={props.showIcon || isHover}
        />
      )}
      {type === "button" && (
        <ButtonMenu
          className={props.className}
          name={props.name}
          onClick={props.onClick}
          showIcon={props.showIcon || isHover}
          value={props.value}
        />
      )}
    </li>
  );
}

export default MenuItem;
